import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import ROUTES from 'constants/routes'

import PlayLearning from 'assets/landing/play-learning.png'
import IconInstagram from 'assets/landing/icon-insta.svg'
import IconIn from 'assets/landing/icon-ln.svg'
import IconYoutube from 'assets/landing/icon-youtube.svg'

import LandingBox from './LandingBox'
import SocialLink from './SocialLink'

function Footer() {
  const { t } = useTranslation()

  return (
    <div className="footer">
      <LandingBox className="footer__box">
        <div className="footer__icons">
          <img className="icon-header" src={PlayLearning} alt="PlayLearning" />
          <div className="footer__separator" />
          <div className="icon-links__wrapper">
            <SocialLink
              icon={IconInstagram}
              link="https://www.instagram.com/playlearning.io/"
              className="icon-link"
              classNameImg="icon-img"
            />
            <SocialLink
              icon={IconIn}
              link="#"
              className="icon-link"
              classNameImg="icon-img icon-img--ln"
            />
            <SocialLink
              icon={IconYoutube}
              link="https://www.youtube.com/channel/UCOJirDehqRHmNG_sVnSuF3w"
              className="icon-link "
              classNameImg="icon-img icon-img--youtube"
            />
          </div>
        </div>
        <div className="footer__links">
          <Link to={ROUTES.LANDING_PRIVACY_POLICY} className="links links--policy">
            {t('landing.footer.privacy_policy')}
          </Link>
          <div className="links">
            {t('landing.footer.powered_by')}
            <a href="https://sanacompany.io/" className="links--company">
              {t('landing.footer.sanacompany_2022')}
            </a>
          </div>
        </div>
      </LandingBox>
    </div>
  )
}

export default memo(Footer)
